export function mapDescriptionHistoryRows(rawHistory, options = {}) {
  const {
    entity,
    entityId,
    fieldName = "Description",
    fallbackUser = "System",
    pageSeed = "page",
  } = options;

  const rows = Array.isArray(rawHistory) ? rawHistory : [];

  return rows.map((item, index) => ({
    changeGroupId: `${item?.id || item?.createdAt || pageSeed}-${index}`,
    modifiedBy: item?.userName || fallbackUser,
    modifiedAt: item?.createdAt || "",
    changes: [
      {
        entity: entity || "history",
        entityId: entityId || "general",
        fieldName,
        previousValue: null,
        newValue: item?.description || "",
      },
    ],
  }));
}
